module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "apple_su.41cbc952.png";